import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentArrowRight24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconDocumentArrowRight24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 20.5h10a1.5 1.5 0 0 0 1.5-1.5v-8.5h-6.49v-7H7A1.5 1.5 0 0 0 5.5 5v14A1.5 1.5 0 0 0 7 20.5M18.347 8.645a.5.5 0 0 1 .153.354h-4.99V3.995zM14.18 2.558l5.205 5.006A2 2 0 0 1 20 9.005V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h5.794a2 2 0 0 1 1.387.558m-1.902 9.762a.75.75 0 0 1 1.06 0l2.476 2.475.53.53-.53.53-2.475 2.475a.75.75 0 0 1-1.061-1.06l1.188-1.189H8.803a.75.75 0 0 1 0-1.5h4.677l-1.201-1.2a.75.75 0 0 1 0-1.061"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentArrowRight24);
